import { CompactRatingComponent } from './CompactRatingComponent';

export const CompactRatingComponentC = CompactRatingComponent;
